import { site } from "@/config/site";

export const Logo = ({ size = "md", variant = "dark", className = "" }) => {
    const sizes = { sm: "h-8", md: "h-10", lg: "h-14" };
    return (
        <img
            src={site.logoUrl}
            alt="Szymkas Agency"
            data-testid="site-logo"
            className={`${sizes[size]} w-auto ${variant === "light" ? "invert-0" : ""} ${className}`}
            loading="eager"
        />
    );
};
